import React, { FC, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './styles.module.css';
import animate from './animate.module.css';
import animateBg from './animateBg.module.css';
import { Asset } from '../Asset';
import classnames from 'classnames';

type ModalProps = {
  showModal: boolean;
  className?: string;
  disableCurtainClick?: boolean;
  onClose?: () => void; // if not provided, do not show close icon
  children?: React.ReactNode;
};

export const Modal: FC<ModalProps> = ({
  showModal,
  onClose,
  children,
  className,
  disableCurtainClick,
}) => {
  const containerRef = useRef(null);
  const windowRef = useRef(null);

  return (
    <CSSTransition
      nodeRef={containerRef}
      in={showModal}
      timeout={400}
      classNames={animateBg}
      unmountOnExit
      appear
    >
      <div
        ref={containerRef}
        className={styles.container}
        onClick={() => !disableCurtainClick && onClose?.()}
      >
        <CSSTransition
          nodeRef={windowRef}
          in={showModal}
          timeout={200}
          classNames={animate}
          unmountOnExit
          appear
        >
          <div
            ref={windowRef}
            className={classnames(styles.window, className)}
            onClick={e => e.stopPropagation()}
          >
            {onClose && (
              <button className={styles.close} onClick={onClose}>
                <Asset variant="close" />
              </button>
            )}
            {children}
          </div>
        </CSSTransition>
      </div>
    </CSSTransition>
  );
};
